import { render, staticRenderFns } from "./notification-form-modal.vue?vue&type=template&id=a1ad4892&"
import script from "./notification-form-modal.vue?vue&type=script&lang=js&"
export * from "./notification-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports